import { CustomerSchema } from "@redotech/redo-model/customer";
import * as z from "zod/v4";

export const getCustomerByEmail = {
  name: "getCustomerByEmail" as const,
  input: z.object({ email: z.string() }),
  output: CustomerSchema,
};
